<template>
    <div class="fixed-scroller">
        <div v-if="show" class="v-alert edit-ad" style="width: 310px;">
            <header><p>Edit Ad</p><div class="x" @click="$emit('exit')"></div></header>
            <Voucher :voucher="ad" />
            <div class="label sm">
                <p>Redeem Ad</p>
                <input v-model="redeemAd" type="checkbox" />
            </div>
            <div class="label sm">
                <p>Expire Ad</p>
                <input v-model="expireAd" type="checkbox" />
            </div>
            <div v-if="expireAd" class="label">
                <p style="width:100px">Expires</p>
                <div class="date-time-box" @change="changeDate">
                    <div>
                        <p>Hr</p>
                        <select v-model="hour"><option v-for="Hr in hours">{{ Hr }}</option></select>
                    </div>
                    <div>
                        <p>Min</p>
                        <select v-model="minute"><option v-for="Min in minutes">{{ Min }}</option></select>
                    </div>
                </div> 
                <div class="date-time-box" @change="changeDate" style="margin-left: 100px;"> 
                    <div>
                        <p>Day</p>
                        <select v-model="day"><option v-for="Day in days">{{ Day }}</option></select>
                    </div>    
                    <div>
                        <p>Mth</p>
                        <select v-model="month"><option v-for="Month in months">{{ Month }}</option></select>
                    </div> 
                    <div>
                        <p>Year</p>
                        <select v-model="year"><option v-for="Year in years">{{ Year }}</option></select>
                    </div>                                       
                </div>
            </div>
            <div class="btns">
                <p class="btn" @click="save">save</p>
            </div>
        </div>
    </div>
</template>

<script>

import Voucher from '../components/Voucher.vue'
import Alert from '../utils/Alert.js'
import WebSoc from '../utils/WebSoc.js';
import { mapActions } from 'vuex'

export default {
    name: 'edit-ad',
    props: ['ad'],
    components: {
        Voucher
    },
    computed: {
        client_id () { return this.$store.state.client_id }
    },
    data () {
        return {
            show: true,
            hours: new Array(24).fill(true).map((_,i) => i).map(i => i < 10 ? '0'+i : i),
            minutes: new Array(60).fill(true).map((_,i) => i).map(i => i < 10 ? '0'+i : i),
            days: new Array(31).fill(true).map((_,i) => i+1).map(i => i < 10 ? '0'+i : i),
            months: new Array(12).fill(true).map((_,i) => i+1).map(i => i < 10 ? '0'+i : i),
            years: new Array(15).fill(true).map((_,i) => (new Date().getFullYear()-2000)+i),
            hour: '00',
            minute: '00',
            day: '01',
            month: '01',
            year: (new Date().getFullYear() - 2000)+'',
            redeemAd: false,
            expireAd: false,
            expires: 0,
            u_expiry: '' 
        }
    },
    mounted () {
        var ad = this.ad;
        this.redeemAd = ad.redeemAd;
        this.expireAd = ad.expireAd;
        this.expires = ad.expires;

        if ( ad.expires > 0 ) {
            var date = new Date(ad.expires);
            this.hour = adZ(date.getHours());
            this.minute = adZ(date.getMinutes());
            this.day = adZ(date.getDate());
            this.month = adZ(date.getMonth() + 1);
            this.year = adZ(date.getFullYear() - 2000);
        }
        
        function adZ(num) { return (num < 9 ? '0' : '')+num }
    },
    methods: {
        save () {
            this.show = false;
            var ad = this.ad;
            var update = ['redeemAd','expireAd','expires'].reduce((p,k) => {
                if ( ad[k] != this[k] ) p[k] = this[k];
                return p
            },{});

            if ( Object.keys(update).length == 0 ) return this.$emit('exit');
            if ( update.expireAd === false ) {
                update.expires = false;
            }

            WebSoc.SEND('search',{ DB: this.client_id+'-customers', find: { 'ads.ad_id': ad.ad_id, 'ads.campaign_id': ad.campaign_id }, project: { _id: 1 } },customers => {
                if ( customers.length > 0 ) { 
                    Alert.yesno('Update '+customers.length+' Member'+(customers.length > 1 ? 's' : '')+'?',yes => {
                        if ( !yes ) return;
                        var updated = 0;
                        WebSoc.SEND('updateCustomerAds',{ client_id: this.client_id, ad_id: ad.ad_id, campaign_id: ad.campaign_id, update, customers },() => {
                            console.log('resp',resp);
                        }) 
                    }) 
                 }
            })
            /*
            Object.keys(update).forEach(key => {
                this.ad[key] = update[key];
            })
            */
            this.$emit('update',{ ad_id: ad.ad_id, campaign_id: ad.campaign_id, update });
            WebSoc.SEND('updateCampaignAds',{ ad_id: ad.ad_id, campaign_id: ad.campaign_id, update },() => {});
            //this.updateAd({ ad_id: ad.ad_id, campaign_id: ad.campaign_id, update });
            this.$emit('exit',{});
        },
        changeDate () {
            var { hour, minute, day, month, year } = this;
            this.expires = new Date(2000 + parseInt(year),month-1,parseInt(day),parseInt(hour),parseInt(minute)).valueOf();
        },
        ...mapActions([
            'updateAd'
        ])
    }
}

</script>

<style lang="scss">
.v-alert.edit-ad {
    .ad-img { margin-bottom: 0px; height: 345px; }
    .label {
        float: left;
        width: 100%;
        > p { float: left; width: 100px; }
        input[type="checkbox"] { margin: -3px 5px; }
    }
    .date-time-box {
        display: grid;
        width: 159px;
        grid-template-columns: 53px 53px 53px;
        gap: 7px;
        float: left;
        select { width: 100% }
    }
}
</style>